exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".editor_container[data-v-dfed83ec]{height:270px;position:relative}.editor_container .text_length[data-v-dfed83ec]{position:absolute;right:20px;bottom:15px;font-size:14px;color:#999}\n", ""]);

// exports
